<template lang="pug">
#inserir-relatorio-rastreabilidade
    BaseHeader#inserir-relatorio-rastreabilidade-header(
        :titulo='$t("mensagens.relatorioRastreabilidade.cadastro.titulo")',
        :exibeBotao='false',
        :voltarPara='true'
    )

    .view-container.margen-bottom-pages
        .bloco-dados-relatorio
            BlocoInserirDadosRelatorio(
                @dadosRelatorio='dadosIniciaisRelatorio',
                @handleValidationFailed='handleValidationFailed',
                :bloquearEdicao='bloquearEdicao',
                ref='dadosIniciaisRelatorio'
            )

        .bloco-protocolo-relatorio
            BlocoProtocolosAnaliseRelatorio(
                @protocoloSelecionado='protocoloSelecionado',
                @handleValidationFailed='handleValidationFailed',
                :bloquearEdicao='bloquearEdicao',
                ref='protocolo'
            )

        .bloco-consulta-analise-rastreabilidade
            BlocoInserirDadosAnaliseRastreabilidade(
                @adicionarTerritorioRelatorioListagem='adicionarTerritorioRelatorioListagem',
                @validarAdicionarListagem='validarAdicionarListagem',
                @validarCamposDadosRelatorio='validarDadosRelatorioResumo',
                @handleValidationFailed='handleValidationFailed',
                @capacidadeProdutiva='capacidadeProdutivaTerritorio',
                @bloqueioDeEdicao='bloqueioDeEdicao',
                :dados='dadosParaRelatorioRastreabilidade',
                ref='analiseRastreabilidade'
            )

        .bloco-preenchimento-em-lote
            BlocoInserirDadosRastreabilidadePlanilha(
                :dados='dadosParaRelatorioRastreabilidade',
                @validarCamposDadosRelatorioLote='validarCamposDadosRelatorioLote',
                @adicionarListagemLote='adicionarListagemLote',
                @bloqueioDeEdicao='bloqueioDeEdicao',
                ref='inserirPlanilhaLote'
            )

        .bloco-novos-relatorios-tabela
            TabelaNaoEnviadosRelatorioRastreabilidade(
                @removerTerritorioLote='removerTerritorioLote',
                @visualizarAnaliseElegibilidade='visualizarAnaliseElegibilidade',
                @volumeTotalAdicionado='volumeTotalTerritorios',
                @bloqueioDeEdicao='bloqueioDeEdicao',
                :relatoriosNaoEnviados='relatoriosNaoEnviados',
                :removendo='removendoTerritoriosRelatorio',
                :volumeContrato='dadosParaRelatorioRastreabilidade.volumeContrato',
                ref='tabelaTerritorio'
            )

        ModalAnaliseElegibilidadeRelatorio(
            :show='ativarModalAnaliseElegibilidade',
            :dados='dadosAnaliseElegibilidade',
            @handleCloseModalAnaliseElegibidade='ativarModalAnaliseElegibilidade = false',
            :idMapa='"mapaAnaliseEleigibilidadeRelatorioVisualizar"'
        )

        footer
            .botao-relatorio__remover
                el-button(
                    v-if='removendoTerritoriosRelatorio',
                    @click.native='removendoTerritoriosRelatorio = false'
                ) {{ $t('mensagens.comuns.cancelar') }}

                el-button(
                    v-if='!removendoTerritoriosRelatorio',
                    type='danger',
                    icon='el-icon-delete',
                    @click.native='removendoTerritoriosRelatorio = true'
                ) {{ $t('mensagens.comuns.remover') }}

                el-button(
                    v-else,
                    type='danger',
                    icon='el-icon-delete',
                    @click.native='removerRelatorio'
                ) {{ $t('mensagens.comuns.confirmarRemocao') }}

            .botao-relatorio__salvar
                el-button#adicionar-analise(
                    :disabled='carregandoSalvar',
                    type='primary',
                    icon='mdi mdi-content-save-outline',
                    @click.native='validarCamposInserirRelatorio'
                ) {{ $t('mensagens.comuns.salvar') }}
</template>

<script>
import BaseHeader from '@/components/BaseHeader';
import BlocoInserirDadosRelatorio from '@/components/relatorioRastreabilidade/BlocoInserirDadosRelatorio.vue';
import BlocoProtocolosAnaliseRelatorio from '@/components/relatorioRastreabilidade/BlocoProtocolosAnaliseRelatorio.vue';
import BlocoInserirDadosAnaliseRastreabilidade from '@/components/relatorioRastreabilidade/BlocoInserirDadosAnaliseRastreabilidade.vue';
import BlocoInserirDadosRastreabilidadePlanilha from '@/components/relatorioRastreabilidade/BlocoInserirDadosRastreabilidadePlanilha.vue';
import TabelaNaoEnviadosRelatorioRastreabilidade from '@/components/relatorioRastreabilidade/TabelaNaoEnviadosRelatorioRastreabilidade.vue';
import RelatorioRastreabilidadeService from '@/services/RelatorioRastreabilidadeService';
import ModalAnaliseElegibilidadeRelatorio from '@/components/relatorioRastreabilidade/ModalAnaliseElegibilidadeRelatorio.vue';
import ContratoOriginacaoServiceSubEmpresa from '@/services/ContratoOriginacaoServiceSubEmpresa';

export default {
    name: 'InserirRelatorio',
    components: {
        BaseHeader,
        BlocoInserirDadosRelatorio,
        BlocoProtocolosAnaliseRelatorio,
        BlocoInserirDadosAnaliseRastreabilidade,
        BlocoInserirDadosRastreabilidadePlanilha,
        TabelaNaoEnviadosRelatorioRastreabilidade,
        ModalAnaliseElegibilidadeRelatorio
    },
    data() {
        return {
            removendoTerritoriosRelatorio: false,
            dados: {},
            dadosParaRelatorioRastreabilidade: {
                numeroContrato: '',
                nomeCultura: '',
                volumeContrato: null,
                idProtocolo: '',
                detalheInput: []
            },
            relatoriosNaoEnviados: [],
            territoriosSelecionados: [],
            validationFailed: false,
            volumeValidationFailed: false,
            ativarModalAnaliseElegibilidade: false,
            dadosAnaliseElegibilidade: {},
            volumeTotalAdicionadoConvertido: '',
            capacidadeProdutiva: '',
            carregandoSalvar: false,
            bloquearEdicao: false
        };
    },
    mounted() {},

    methods: {
        dadosIniciaisRelatorio(dadosRelatorio) {
            this.dados = dadosRelatorio;

            this.dadosParaRelatorioRastreabilidade.numeroContrato =
                dadosRelatorio.numeroContrato;
            this.dadosParaRelatorioRastreabilidade.nomeCultura =
                dadosRelatorio.nomeCultura;
            this.dadosParaRelatorioRastreabilidade.volumeContrato = parseFloat(
                dadosRelatorio.volumeContrato.replace(',', '.')
            );
        },

        protocoloSelecionado(idProtocoloSelecionado) {
            this.dadosParaRelatorioRastreabilidade.idProtocolo =
                idProtocoloSelecionado;
        },

        bloqueioDeEdicao(valor) {
            if (!valor) {
                if (!this.relatoriosNaoEnviados.length) {
                    this.bloquearEdicao = false;
                }
            } else {
                this.bloquearEdicao = valor;
            }
        },

        adicionarTerritorioRelatorioListagem(dadosRelatorioDiagnostico) {
            if (!this.bloquearEdicao) {
                this.bloquearEdicao = true;
            }

            this.dadosParaRelatorioRastreabilidade.detalheInput.push(
                dadosRelatorioDiagnostico
            );
            this.relatoriosNaoEnviados =
                this.dadosParaRelatorioRastreabilidade.detalheInput;
        },

        adicionarListagemLote(dadosRelatorioDiagnosticoPlanilha, volume) {
            if (
                volume >
                    this.dadosParaRelatorioRastreabilidade.volumeContrato ||
                volume + this.volumeTotalAdicionadoConvertido >
                    this.dadosParaRelatorioRastreabilidade.volumeContrato
            ) {
                this.$notify.error({
                    message: this.$t(
                        'mensagens.relatorioRastreabilidade.cadastro.volumeExcedeVolumeContrato'
                    )
                });
                this.volumeValidationFailed = true;
                return;
            }

            if (
                this.carExisteNaListagemLote(dadosRelatorioDiagnosticoPlanilha)
            ) {
                this.$notify.error({
                    message: this.$t(
                        'mensagens.relatorioRastreabilidade.cadastro.carJaInseridoListagem'
                    )
                });
                return;
            }

            if (!this.bloquearEdicao) {
                this.bloquearEdicao = true;
            }

            this.dadosParaRelatorioRastreabilidade.detalheInput.push(
                ...dadosRelatorioDiagnosticoPlanilha
            );
            this.relatoriosNaoEnviados =
                this.dadosParaRelatorioRastreabilidade.detalheInput;

            this.$refs.inserirPlanilhaLote.limparDadosPlanilha();
        },

        validarDadosRelatorioResumo() {
            this.validationFailed = false;

            this.$refs.dadosIniciaisRelatorio.validateForm();
            this.$refs.protocolo.validateForm();

            if (this.validationFailed) {
                this.$notify.warning(
                    this.$t(
                        'mensagens.relatorioRastreabilidade.cadastro.camposPrecisamEstarPreenchidosCorretamente'
                    )
                );
            } else {
                this.$refs.analiseRastreabilidade.validarRealizarResumo();
            }
        },

        validarCamposDadosRelatorioLote() {
            this.validationFailed = false;

            this.$refs.dadosIniciaisRelatorio.validateForm();
            this.$refs.protocolo.validateForm();

            if (this.validationFailed) {
                this.$notify.warning(
                    this.$t(
                        'mensagens.relatorioRastreabilidade.cadastro.camposPrecisamEstarPreenchidosCorretamente'
                    )
                );
            } else {
                this.$refs.inserirPlanilhaLote.$refs.uploadPlanilhaTerritorio.$el
                    .querySelector('.el-upload__input')
                    .click();
            }
        },

        handleValidationFailed() {
            this.validationFailed = true;
        },

        validarCamposInserirRelatorio() {
            this.validationFailed = false;

            this.$refs.dadosIniciaisRelatorio.validateForm();
            this.$refs.protocolo.validateForm();

            if (this.validationFailed) {
                this.$notify.warning(
                    this.$t(
                        'mensagens.relatorioRastreabilidade.cadastro.camposPrecisamEstarPreenchidosCorretamente'
                    )
                );
            } else {
                this.inserirRelatorioRastreabilidade();
            }
        },

        async inserirRelatorioRastreabilidade() {
            if (this.carregandoSalvar) {
                return;
            }
            if (!this.dadosParaRelatorioRastreabilidade.detalheInput.length) {
                this.$notify.error({
                    message: this.$t(
                        'mensagens.relatorioRastreabilidade.cadastro.necessarioInserirAoMenosUmTerritorio'
                    )
                });
                return;
            }

            if (
                this.volumeTotalAdicionadoConvertido >
                this.dadosParaRelatorioRastreabilidade.volumeContrato
            ) {
                this.$notify.error({
                    message:
                        this.$t(
                            'mensagens.relatorioRastreabilidade.cadastro.volumeAlterado'
                        ) +
                        ' ' +
                        this.$t(
                            'mensagens.relatorioRastreabilidade.cadastro.volumeExcedente'
                        ) +
                        ': ' +
                        (this.volumeTotalAdicionadoConvertido -
                            this.dadosParaRelatorioRastreabilidade
                                .volumeContrato) +
                        ' (t).'
                });
                return;
            }

            if (
                this.dadosParaRelatorioRastreabilidade.detalheInput.some(
                    item => item.situacao === 'INCONFORME'
                ) ||
                this.dadosParaRelatorioRastreabilidade.detalheInput.some(
                    item => item.situacao === 'ALERTA'
                )
            ) {
                this.$notify.error({
                    message: this.$t(
                        'mensagens.relatorioRastreabilidade.cadastro.necessarioRemoverTerritorios'
                    )
                });
                return;
            }

            this.carregandoSalvar = true;

            try {
                await RelatorioRastreabilidadeService.inserirRelatorios(
                    this.dadosParaRelatorioRastreabilidade
                );

                this.$notify.success(
                    this.$t(
                        'mensagens.relatorioRastreabilidade.cadastro.relatorioInseridoSucesso'
                    )
                );
                this.$router.push({ name: 'RelatorioRastreabilidade' });
            } catch (error) {
                this.$notify.error({
                    message: error.response.data.message
                });
            }
            this.carregandoSalvar = false;
        },

        removerTerritorioLote(idsTerritorios) {
            this.territoriosSelecionados = idsTerritorios;
        },

        async removerRelatorio() {
            if (this.territoriosSelecionados.length === 0) {
                this.$notify.warning(
                    this.$t(
                        'mensagens.relatorioRastreabilidade.cadastro.naoHaTerritoriosSelecionadoParaRemocao'
                    )
                );
            } else {
                this.$nextTick(() => {
                    this.$refs.tabelaTerritorio.removerTerritorio(
                        this.territoriosSelecionados
                    );

                    this.$refs.analiseRastreabilidade.limparTerritorios();
                    this.$refs.inserirPlanilhaLote.resetarElegibilidade();
                });
            }
        },

        limparDadosResumo() {
            this.dadosAnaliseElegibilidade = {
                valor: '',
                dadosDiagnostico: {
                    diagnosticoRepresentante: [],
                    diagnosticoCar: null,
                    resultadoDiagnosticoRastreabilidade: null,
                    nivelAlertaRastreabilidade: null
                },
                dadosCalculoRaio: {
                    distanciaRaioMunicipioECar: null,
                    possuiIntersecao: null
                },
                dadosBuscaSaldo: {
                    id: null,
                    codigoCar: '',
                    capacidadeProdutiva: null,
                    saldoCARcapacidadeProdutiva: null,
                    cultura: {
                        id: null,
                        nome: '',
                        codigo: ''
                    },
                    anoSafra: {
                        id: null,
                        ano: null,
                        tipoSafra: '',
                        descricao: ''
                    },
                    criadoEm: null,
                    saldoCarComprometido: null
                },
                carregandoBuscarCpfCnpj: false
            };
        },

        visualizarAnaliseElegibilidade(row) {
            if (!row?.dadosAnaliseElegibilidade) {
                this.realizarAnaliseElegibilidade(row);
            } else {
                this.dadosAnaliseElegibilidade = row.dadosAnaliseElegibilidade;
                this.ativarModalAnaliseElegibilidade = true;
            }
        },

        async realizarAnaliseElegibilidade(row) {
            this.limparDadosResumo();
            this.dadosAnaliseElegibilidade.dadosDiagnostico = JSON.parse(
                row.resultadoDiagnostico
            );

            this.dadosAnaliseElegibilidade.safraNome = row.anoSafra;

            this.buscarSaldo(row);
            this.analisarElegibilidade();
        },

        analisarElegibilidade() {
            if (
                this.dadosAnaliseElegibilidade.dadosDiagnostico
                    .resultadoDiagnosticoRastreabilidade === null
            ) {
                return;
            }

            if (
                this.dadosAnaliseElegibilidade.dadosBuscaSaldo
                    .saldoCARcapacidadeProdutiva === null
            ) {
                return;
            }
            let resultadoElegibilidade = 'INDEFINIDO';
            if (
                this.dadosAnaliseElegibilidade.dadosDiagnostico
                    .resultadoDiagnosticoRastreabilidade === 'INCONFORME'
            ) {
                resultadoElegibilidade = 'INELEGIVEL';
            } else if (
                this.dadosAnaliseElegibilidade.dadosDiagnostico
                    .nivelAlertaRastreabilidade === 'MEDIO_ALTO'
            ) {
                resultadoElegibilidade = 'ALERTA';
            } else {
                resultadoElegibilidade = 'ELEGIVEL';
            }

            if (
                this.dadosAnaliseElegibilidade.dadosCalculoRaio
                    .distanciaRaioMunicipioECar > this.limiteRaio
            ) {
                resultadoElegibilidade = 'INELEGIVEL';
            }

            if (
                this.dadosAnaliseElegibilidade.dadosBuscaSaldo
                    .saldoCARcapacidadeProdutiva <= 0
            ) {
                resultadoElegibilidade = 'INELEGIVEL';
            }

            this.dadosAnaliseElegibilidade.elegibilidade =
                resultadoElegibilidade;

            this.ativarModalAnaliseElegibilidade = true;
        },

        async buscarSaldo(row) {
            const dados = {
                codigoCar: row.codigoCar,
                nomeMaterial:
                    this.dadosParaRelatorioRastreabilidade.nomeCultura,
                anoSafra: row.anoSafra,
                numeroContrato:
                    this.dadosParaRelatorioRastreabilidade.numeroContrato,
                idTerritorio: 0
            };

            try {
                const response =
                    await ContratoOriginacaoServiceSubEmpresa.buscarSaldo(
                        dados,
                        true
                    );
                this.dadosAnaliseElegibilidade.dadosBuscaSaldo = response.data;

                this.analisarElegibilidade();
            } catch (error) {
                this.$notify.error({
                    message: error.response.data.message
                });
            }
        },

        validarAdicionarListagem(volumeTerritorio, car) {
            this.validationFailed = false;

            this.$refs.analiseRastreabilidade.validateForm();
            this.$refs.analiseRastreabilidade.validateFormVolume();

            if (this.carExisteNaListagem(car)) {
                this.$notify.error({
                    message: this.$t(
                        'mensagens.relatorioRastreabilidade.cadastro.carInformadoJaInseridoListagem'
                    )
                });
                return;
            }

            this.validaVolumeDisponivel(volumeTerritorio);

            if (this.validationFailed) {
                this.$notify.warning(
                    this.$t(
                        'mensagens.relatorioRastreabilidade.cadastro.camposPrecisamEstarPreenchidosCorretamente'
                    )
                );
            } else if (this.volumeValidationFailed) {
            } else {
                this.$refs.analiseRastreabilidade.adicionarTerritorioListagem();
            }
        },

        carExisteNaListagem(car) {
            return this.relatoriosNaoEnviados.some(
                territorio => territorio.codigoCar === car
            );
        },

        carExisteNaListagemLote(dadosRelatorioDiagnosticoPlanilha) {
            return dadosRelatorioDiagnosticoPlanilha.some(item => {
                return this.relatoriosNaoEnviados.some(
                    relatorio => relatorio.codigoCar === item.codigoCar
                );
            });
        },

        volumeTotalTerritorios(volumeTotalAdicionado) {
            this.volumeTotalAdicionadoConvertido = parseFloat(
                volumeTotalAdicionado.replace(',', '.')
            );
        },

        capacidadeProdutivaTerritorio(capacidadeProdutiva) {
            this.capacidadeProdutiva = capacidadeProdutiva;
        },

        validaVolumeDisponivel(volumeTerritorio) {
            const volumeTerritorioNumero = parseFloat(
                volumeTerritorio.replace(',', '.')
            );

            this.volumeValidationFailed = false;
            if (volumeTerritorioNumero > this.capacidadeProdutiva) {
                this.$notify.error({
                    message:
                        'O volume informado excede a capacidade produtiva deste CAR.'
                });
                this.volumeValidationFailed = true;
                return;
            }
            if (
                volumeTerritorioNumero >
                    this.dadosParaRelatorioRastreabilidade.volumeContrato &&
                volumeTerritorioNumero + this.volumeTotalAdicionadoConvertido >
                    this.dadosParaRelatorioRastreabilidade.volumeContrato
            ) {
                this.$notify.error({
                    message: 'Volume informado excede o volume do contrato.'
                });
                this.volumeValidationFailed = true;
                return;
            }

            if (
                volumeTerritorioNumero + this.volumeTotalAdicionadoConvertido >
                this.dadosParaRelatorioRastreabilidade.volumeContrato
            ) {
                this.$notify.error({
                    message:
                        'Volume informado excede o volume disponivel no contrato.'
                });
                this.volumeValidationFailed = true;
            }
        }
    }
};
</script>

<style lang="scss">
#inserir-relatorio-rastreabilidade {
    .secao-listagem {
        display: flex;
        margin-top: 20px;
        gap: 25px;
        justify-content: space-between;

        .titulo-listagem h3 {
            font-weight: bold;
        }
    }

    .secao-listagem,
    .bloco-dados-relatorio,
    .bloco-protocolo-relatorio,
    .bloco-consulta-analise-rastreabilidade,
    .bloco-preenchimento-em-lote,
    .bloco-novos-relatorios-tabela {
        margin-top: 20px;
    }

    footer {
        display: flex;
        align-items: center;
        justify-content: space-between;

        .botao-relatorio__remover,
        .botao-relatorio__salvar {
            margin-top: 16px;
            .lyra-icon.lyra-grafico ::after {
                color: white;
            }

            #adicionar-analise {
                span {
                    margin-left: 5px;
                }
            }
        }
    }
}
</style>
